import { h } from 'preact';
import {
  getOutOfStockLabelText,
  shouldShowOutOfStockBadge,
  showOutOfStockHomeGrid
} from '../../lib/Inventory';
import { getCatalogueTheme } from '../../lib/Theme';
import { HOME_LAYOUT_TYPE } from '../../lib/Utils';
import './index.less';

export const VIEW_TYPES = {
  HOME_GRID: 'HOME_GRID',
  GALLERY_VIEW: 'GALLERY_VIEW',
  SEARCH_GRID: 'SEARCH_GRID'
};

export default ({ productId, type, homeLayoutType, fromCustomPage, showBadge }) => {
  let showOutOfStockBadge = null;

  if (type === VIEW_TYPES.HOME_GRID) {
    showOutOfStockBadge = showOutOfStockHomeGrid(productId, fromCustomPage);
  } else {
    showOutOfStockBadge = shouldShowOutOfStockBadge(productId, fromCustomPage);
  }

  if (!showOutOfStockBadge && !showBadge) {
    return null;
  }

  const outOfStockLabelText = getOutOfStockLabelText();
  const theme = getCatalogueTheme().homeGrid.outOfStockBadge;

  return (
    <div
      className={`out-of-stock-badge ${
        homeLayoutType === HOME_LAYOUT_TYPE.MAGAZINE
          ? 'out-of-stock-badge-magazine'
          : homeLayoutType === HOME_LAYOUT_TYPE.LIST
            ? 'out-of-stock-badge-list'
            : 'out-of-stock-badge-grid'
      } `}
      style={{
        backgroundColor: theme.backgroundColor,
        color: theme.textColor
      }}
    >
      <span>{outOfStockLabelText}</span>
    </div>
  );
};
